export default {
  buttons: {
    add: 'add',
    save: 'save',
    search: 'search',
    delete: 'delete',
    cancel: 'cancel',
    confirm: 'confirm',
    complete: 'complete',
    importMemos: 'import highlights',
    selfInput: 'add manually',
    close: 'close'
  },
  alerts: {
    login: 'Login required'
  },
  words: {
    memo: 'note | notes',
    book: 'book | books',
    tos: 'terms of service',
    privacyPolicy: 'privacy policy',
    or: 'or',
    tag: 'tag | tags',
    sort: 'sort'
  },
  labels: {
    id: 'id',
    email: 'email',
    password: 'password'
  },
  messages: {
    hasAccount: 'Already have an account?',
    appUpdateRequired: 'App update required.'
  },
  noti: {
    headers: {
      upgrade: 'Need an account upgrade',
      login: 'Login required'
    },
    messages: {
      userAccessExcerpts:
        'To add more than two excerpts per note, an account upgrade is required. Check out the pricing page?',
      userAccessMemos:
        'To add more than 100 notes, an account upgrade is required. Check out the pricing page?',
      userAccessQuota:
        'To use more than quota, an account upgrade is required. Check out the pricing page?',
      userAccessPdfExporting:
        'To export notes as PDF, account upgrade is required. Check out the pricing page?',
      userAccess:
        'To use this feature, account upgrade is required. Check out the pricing page?',
      signInNeeded: 'Login is required. Go to sign-in page?',
      equalPlatformRequired:
        'Please change your subscription on the platform you have subscribed',
      fileNeeded: 'Please add a file.',
      charsExceeded:
        'The number of characters allowed is exceeded. ({num}/{max})'
    }
  },
  services: {
    ridi: '리디북스',
    millie: '밀리의서재'
  },
  terms: {
    readgraphyLogo: 'readgraphy logo',
    review: 'review',
    earlybird: 'earlybird',
    month: 'month | months',
    year: 'year | years',
    tag: 'tag | tags',
    readgraphy: 'readgraphy',
    paidPlan: 'paid',
    freePlan: 'free',
    planInfo: 'pricing',
    allTags: 'all tags',
    korean: 'korean',
    english: 'english',
    aladin: 'Aladin',
    gbooks: 'Google Books',
    logout: 'log out',
    addTag: 'add tag',
    noTags: 'no tags (create with right button)',
    billedMonthly: 'billed monthly',
    billedAnnual: 'billed annual',
    deleteAccount: 'delete your account',
    share: 'share',
    download: 'download',
    backToLibrary: 'back to library',
    myLibrary: 'my library',
    getStarted: 'get started',
    numSelected: '{count} selected',
    close: 'close',
    copy: 'copy',
    notice: 'Notice'
  },
  noty: {
    ADDED: 'Added',
    UPDATED: 'Updated',
    IMPORTED: 'Imported',
    SENT: 'Sent',
    URL_COPIED: 'URL copied',
    ONLINE_RECOVERY: 'Internet connected',
    OFFLINE: 'No internet connection',
    RETRY: 'Retry',
    ERROR_PERMISSION: 'Invalid data',
    ERROR_ITEMS_EXCEEDED: 'Number exceeded',
    ERROR_INVALID_AUTH: 'Invalid auth',
    ERROR_INVALID_PROVIDER: 'Invalid provider',
    ERROR_PAYMENT_DECLINED: 'Payment declined',
    ERROR_UNKNOWN: 'Unknown error',
    ERROR_NOT_FOUND: 'Data not found',
    ERROR_NO_QUOTA: 'Quota exceeded',
    ERROR_ADMIN_CONTACT: 'Contact admin'
  },
  routes: {
    signup: 'Sign up',
    signin: 'Sign in',
    searchBook: 'Search for books to add',
    myLibrary: 'My library',
    toc: 'Table of contents',
    forgot: 'Change password',
    privacy: 'Privacy Policy',
    tos: 'Terms of service',
    settings: 'Settings',
    tags: 'Tags',
    pricing: 'Pricing',
    services: 'eBook providers',
    serviceRegister: 'Import from {service}',
    deleteAccount: 'Delete your account',
    shareExcerpt: 'Share excerpt as image',
    highlighting: 'Highlighting',
    charts: 'Reading charts',
    addToList: 'Add to list',
    notelists: 'Note lists',
    review: 'Review',
    reviewEdit: 'Write a review'
  }
}
